<template>
  <v-dialog
    :value="value"
    max-width="480"
    persistent
    data-testid="delete-cancel-confirm-modal"
    @input="$emit('input', $event)"
  >
    <v-card class="delete-cancel-confirm-modal">
      <v-card-title class="delete-cancel-confirm-modal__header white--text">
        <span>{{ title }}</span>
        <v-spacer />
        <v-btn
          icon
          dark
          data-testid="delete-cancel-confirm-modal__close-btn"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="delete-cancel-confirm-modal__body pt-6">
        {{ message }}
      </v-card-text>

      <v-card-actions class="delete-cancel-confirm-modal__footer px-6 pb-6">
        <v-spacer />
        <v-btn
          outlined
          class="delete-cancel-confirm-modal__keep-btn text-capitalize secondaryBtn"
          data-testid="delete-cancel-confirm-modal__keep-btn"
          @click="close"
        >
          No, Keep It
        </v-btn>
        <v-btn
          :color="confirmColor"
          class="white--text text-capitalize ml-3"
          :loading="loading"
          data-testid="delete-cancel-confirm-modal__confirm-btn"
          @click="$emit('confirm')"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import './DeleteCancelConfirmModal.scss';

const VARIANTS = {
  delete: {
    title: 'Delete request',
    message: 'Are you sure you want to delete this request? All associated files and data will be permanently removed.',
    confirmLabel: 'Yes, Delete',
    confirmColor: 'var(--color-danger-strong, #d21717)',
  },
  cancel: {
    title: 'Cancel Request',
    message: 'Are you sure you want to cancel this request? This action cannot be undone.',
    confirmLabel: 'Yes, Cancel',
    confirmColor: 'var(--color-primary-base, #193541)',
  },
  'delete-owner': {
    title: 'Delete information owner',
    message: 'Are you sure you want to delete this information owner? This cannot be undone.',
    confirmLabel: 'Yes, Delete',
    confirmColor: 'var(--color-danger-strong, #d21717)',
  },
};

export default {
  name: 'DeleteCancelConfirmModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'delete',
      validator: (v) => ['delete', 'cancel', 'delete-owner'].includes(v),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    customMessage: {
      type: String,
      default: '',
    },
    customTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    config() {
      return VARIANTS[this.variant] || VARIANTS.delete;
    },
    title() {
      return this.customTitle || this.config.title;
    },
    message() {
      return this.customMessage || this.config.message;
    },
    confirmLabel() {
      return this.config.confirmLabel;
    },
    confirmColor() {
      return this.config.confirmColor;
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
};
</script>
